'use strict';

var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');

var SchemaSetting = Backbone.Model.extend({
    initialize: function (options) {
        this.deviceID = options.deviceID;
        this.changedValue = options.changedValue;
        this.circuit_nr = options.circuit_nr;
    },

    url: function () {
        return '/api/v1/devices/' + this.deviceID + '/circuits/' + this.circuit_nr + '/schema/' + this.changedValue;
    },
});

var SchemaSettingsDialogView = Marionette.ItemView.extend({
    ui: {
        slider: '#js-slider',
        dropdown: '#js-pump-state',

        btnPlus: '#js-plus',
        btnMinus: '#js-minus',
        btnSave: '#js-save',

        errorMsg: '#error-msg',
    },

    events: {
        'click @ui.btnPlus': 'sliderPlus',
        'click @ui.btnMinus': 'sliderMinus',
        'click @ui.btnSave': 'save',
    },

    initialize: function (options) {
        this.options = options;
        this.template = options.template;
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.label = this.options.label;
        data.state = this.options.state;
        data.value = this.options.value;

        return data;
    },

    sliderPlus: function () {
        var current = this.ui.slider.slider('getValue');
        if (current < this.max) {
            this.ui.slider.slider('setValue', current + 1);
        }
    },

    sliderMinus: function () {
        var current = this.ui.slider.slider('getValue');
        if (current > this.min) {
            this.ui.slider.slider('setValue', current - 1);
        }
    },

    save: function () {
        // get value/state
        if (this.options.slider != undefined) {
            // slider exists -> read current value
            var value = this.ui.slider.slider('getValue');
            // adapt value
            if (value == 0) {
                value = 'auto';
            } else {
                if (this.options.label == 'AF1') {
                    // convert to temperature
                    value = (value - 1) * 5 - 400;
                } else {
                    // convert to percentage value
                    value = value - 1;
                }
            }
        } else {
            // no slider exists -> read value from drop-down
            var value = this.ui.dropdown.val();
        }

        // create model from changed state
        var setting = new SchemaSetting({
            deviceID: this.options.deviceID,
            changedValue: this.options.label,
            value: value.toString(),
            circuit_nr: this.options.circuitNr,
        });

        this.ui.errorMsg.addClass('invisible');
        Decorator.disableElement('.modal-dialog');

        var self = this;
        setting.save(
            { id: this.options.circuitNr },
            {
                success: function (value, schema) {
                    self.options.save_cb(value, schema);
                },
                error: function (model, response) {
                    var error = i18n.TR('Wert konnte nicht geschrieben werden.');
                    // received non-empty error from backend? -> show user specific error message
                    if (response && response.responseText) {
                        error = response.responseText.trim() || error;
                    }
                    self.ui.errorMsg.text(error);
                    self.ui.errorMsg.removeClass('invisible');
                    Decorator.enableElement('.modal-dialog');
                },
            }
        );
    },

    onBeforeDestroy: function () {
        // destroy slider
        this.ui.slider.slider('destroy');
    },

    onShow: function () {
        // initialize slider (if any)
        if (this.options.slider != undefined) {
            var self = this;
            $('#js-modal-dialog').one('shown.bs.modal', function () {
                // slider is initialized indirectly, see:
                // https://github.com/seiyria/bootstrap-slider/issues/396
                self.ui.slider.slider(self.options.slider);

                self.min = self.ui.slider.slider('getAttribute', 'min');
                self.max = self.ui.slider.slider('getAttribute', 'max');
            });
        }
    },
});

module.exports = SchemaSettingsDialogView;
